/* Douvella — page produit : variantes, galerie, visionneuse, ajout au panier,
   date de livraison estimée, barre d'achat collante, recommandations. */
(() => {
  if (window.DouvellaProduct) return;

  const money = (cents, currency) => {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100); }
    catch (_) { return `${(cents / 100).toFixed(2).replace('.', ',')} €`; }
  };

  /* Ajoute n jours ouvrés (lun.–ven.) à une date */
  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    let added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); const wd = d.getDay(); if (wd !== 0 && wd !== 6) added += 1; }
    return d;
  };
  const fmtDay = (d) => d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '');

  function initProduct(root) {
    if (root.dataset.dvReady) return;
    root.dataset.dvReady = '1';

    const data = JSON.parse(root.querySelector('[data-dv-product-json]')?.textContent || '{}');
    const currency = root.dataset.currency || 'EUR';
    const form = root.querySelector('[data-dv-form]');
    const idInput = form?.querySelector('input[name="id"]');
    const atcs = document.querySelectorAll(`[data-dv-atc="${root.dataset.section}"]`);
    const priceNow = root.querySelectorAll('[data-dv-price]');
    const priceWas = root.querySelector('[data-dv-was]');
    const priceOff = root.querySelector('[data-dv-off]');
    const error = root.querySelector('[data-dv-error]');
    const track = root.querySelector('.dv-gal__track');
    const variantSlot = track?.querySelector('[data-dv-variant-slot]');
    let variantMediaRequested = false;

    /* Les vidéos Shopify conservent leur miniature, puis ne chargent et ne
       démarrent que lorsqu'elles deviennent réellement visibles. */
    const galleryVideos = [...root.querySelectorAll('video.dv-gal__video')];
    galleryVideos.forEach((video) => {
      video.addEventListener('playing', () => {
        const shell = video.closest('.dv-video-shell');
        const poster = shell?.querySelector('.dv-video-poster');
        shell?.classList.add('is-playing');
        if (poster) poster.hidden = true;
      }, { once: true });
    });
    const playVideo = (video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.removeAttribute('controls');
      if (video.preload === 'none') {
        video.preload = 'metadata';
        video.load();
      }
      const playback = video.play();
      if (playback?.catch) playback.catch(() => {});
    };
    const pauseVideo = (video) => video.pause();

    const priorityVideo = root.querySelector('video.dv-gal__video--priority');
    if (priorityVideo) playVideo(priorityVideo);

    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.55) playVideo(entry.target);
          else pauseVideo(entry.target);
        });
      }, { threshold: [0, 0.55] });
      galleryVideos.forEach((video) => videoObserver.observe(video));
    } else {
      galleryVideos.forEach(playVideo);
    }

    const variantSlotIndex = () => {
      if (!track || !variantSlot) return 0;
      return Math.max(0, [...track.children].indexOf(variantSlot));
    };

    /* Le média de variante est déjà rendu à sa place Shopify.
       Mobile : la galerie passe sur ce média et l'écran remonte jusqu'à elle.
       PC : ce média prend la place de l'image 1, et l'image 1 prend la sienne.
       Les autres images ne bougent pas. */
    const galleryBlock = root.querySelector('.dv-gal');
    const galleryBadge = root.querySelector('[data-dv-gallery-badge]');
    const originalItems = track ? [...track.children] : [];
    const originalSizes = originalItems.map((item) => item.querySelector('img')?.getAttribute('sizes') || '');

    const placeFirstOnDesktop = (target) => {
      if (!track || !originalItems.length) return;
      const order = [...originalItems];
      const targetIndex = target ? order.indexOf(target) : -1;
      if (targetIndex > 0) [order[0], order[targetIndex]] = [order[targetIndex], order[0]];
      order.forEach((item, position) => {
        track.appendChild(item);
        /* L'image reprend la résolution prévue pour sa nouvelle case. */
        const img = item.querySelector('img');
        if (img && originalSizes[position]) img.setAttribute('sizes', originalSizes[position]);
      });
      /* Le badge « Très populaire » reste sur la deuxième case. */
      if (galleryBadge) (order[1] || order[0]).appendChild(galleryBadge);
    };

    const showVariantImage = (variant) => {
      if (!track) return;
      const mediaId = variant?.featured_media?.id;
      const target = mediaId
        ? originalItems.find((item) => String(item.dataset.mediaId) === String(mediaId))
        : null;

      if (desktopGallery()) {
        placeFirstOnDesktop(target);
        const first = track.firstElementChild;
        goTo(Math.max(0, originalItems.indexOf(first)), 'auto');
        first?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }

      goTo(Math.max(0, originalItems.indexOf(target || variantSlot)), 'auto');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      galleryBlock?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    };

    /* Si la fenêtre passe du format PC au format mobile, l'ordre Shopify revient. */
    window.matchMedia('(min-width: 990px)').addEventListener?.('change', (event) => {
      if (!event.matches) placeFirstOnDesktop(null);
    });

    /* ---------- Variantes ---------- */
    const current = () => data.variants?.find((v) => String(v.id) === String(idInput?.value));
    const selected = () => [...root.querySelectorAll('.dv-opt')].map((fs) => fs.querySelector('input:checked')?.value);

    const paintAvailability = () => {
      const sel = selected();
      root.querySelectorAll('.dv-opt').forEach((fs, idx) => {
        fs.querySelectorAll('input').forEach((input) => {
          const test = [...sel]; test[idx] = input.value;
          const ok = data.variants.some((v) => v.available && v.options.every((o, i) => o === test[i]));
          input.nextElementSibling?.classList.toggle('is-out', !ok);
        });
      });
    };

    const paint = (variant) => {
      if (!variant) {
        atcs.forEach((b) => { b.disabled = true; b.querySelector('[data-dv-atc-label]').textContent = 'Indisponible'; });
        return;
      }
      idInput.value = variant.id;
      priceNow.forEach((n) => { n.textContent = money(variant.price, currency); });
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceWas) { priceWas.hidden = !onSale; priceWas.textContent = onSale ? money(variant.compare_at_price, currency) : ''; }
      if (priceOff) { priceOff.hidden = !onSale; priceOff.textContent = onSale ? `−${Math.round((1 - variant.price / variant.compare_at_price) * 100)} %` : ''; }
      atcs.forEach((b) => {
        b.disabled = !variant.available;
        b.querySelector('[data-dv-atc-label]').textContent = variant.available ? b.dataset.labelAdd : b.dataset.labelSoldout;
        const p = b.querySelector('[data-dv-atc-price]'); if (p) p.textContent = money(variant.price, currency);
      });
      root.querySelectorAll('.dv-opt').forEach((fs) => {
        const v = fs.querySelector('input:checked')?.value; const out = fs.querySelector('[data-dv-opt-value]'); if (out && v) out.textContent = v;
      });
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      paintAvailability();
      error && (error.hidden = true);
    };

    root.querySelectorAll('.dv-opt input').forEach((input) => input.addEventListener('change', (event) => {
      const sel = selected();
      const variant = data.variants.find((v) => v.options.every((o, i) => o === sel[i]));
      paint(variant);
      if (event.isTrusted) {
        variantMediaRequested = true;
        showVariantImage(variant);
      }
    }));
    root.querySelectorAll('.dv-opt label[for]').forEach((label) => label.addEventListener('click', (event) => {
      if (!event.isTrusted) return;
      const controlledInput = document.getElementById(label.htmlFor);
      if (!controlledInput?.checked) return;
      variantMediaRequested = true;
      requestAnimationFrame(() => showVariantImage(current()));
    }));
    if (data.variants?.length) paintAvailability();

    /* ---------- Quantité ---------- */
    const qty = root.querySelector('.dv-qty input');
    root.querySelectorAll('[data-dv-qty]').forEach((b) => b.addEventListener('click', () => {
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.dvQty));
    }));

    /* ---------- Ajout au panier (tiroir du thème si présent) ---------- */
    atcs.forEach((button) => button.addEventListener('click', (e) => {
      if (!form || button.disabled) return;
      e.preventDefault();
      if (error) error.hidden = true;
      if (window.SkovnCart?.addForm) {
        button.classList.add('is-loading');
        window.SkovnCart.addForm(form, { button })
          .catch((err) => { if (error) { error.textContent = err?.message || "Ce produit n'a pas pu être ajouté."; error.hidden = false; } })
          .finally(() => button.classList.remove('is-loading'));
      } else {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      }
    }));

    /* ---------- Date de livraison estimée ---------- */
    const eta = root.querySelector('[data-dv-eta]');
    if (eta) {
      const min = Number(eta.dataset.min || 5); const max = Number(eta.dataset.max || 8);
      const now = new Date(); const cutoff = Number(eta.dataset.cutoff || 14);
      const start = now.getHours() >= cutoff ? addBusinessDays(now, 1) : now;
      eta.textContent = `entre le ${fmtDay(addBusinessDays(start, min))} et le ${fmtDay(addBusinessDays(start, max))}`;
    }

    /* ---------- Galerie : visionneuse, miniatures, flèches ---------- */
    const items = track ? [...track.children] : [];
    const thumbs = [...root.querySelectorAll('.dv-gal__thumb')];
    const count = root.querySelector('.dv-gal__count');
    let index = 0;
    let syncGalleryState = () => {};

    const desktopGallery = () => window.matchMedia('(min-width: 990px)').matches;

    function goTo(i, behavior = 'smooth') {
      if (!track || !items.length) return;
      index = (i + items.length) % items.length;
      if (desktopGallery()) {
        items.forEach((item, itemIndex) => item.classList.toggle('is-dv-active', itemIndex === index));
        /* En mosaïque PC, le chargement initial ne déplace pas la page.
           Seul un défilement doux demandé amène au média correspondant. */
        if (behavior === 'smooth') {
          items[index].scrollIntoView({ behavior, block: 'center' });
        }
        syncGalleryState();
        return;
      }
      if (behavior === 'smooth') {
        track.scrollTo({ left: items[index].offsetLeft, behavior });
        return;
      }
      /* Positionnement immédiat, même si le CSS impose un défilement doux. */
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = items[index].offsetLeft;
      track.style.scrollBehavior = '';
    }
    if (track) {
      const nearestIndex = () => items.reduce((closest, item, itemIndex) => {
        const closestDistance = Math.abs(items[closest].offsetLeft - track.scrollLeft);
        const itemDistance = Math.abs(item.offsetLeft - track.scrollLeft);
        return itemDistance < closestDistance ? itemIndex : closest;
      }, 0);
      const stepIndex = (startIndex, direction) => {
        const firstIndex = variantSlotIndex();
        if (direction > 0 && startIndex === items.length - 1) return firstIndex;
        if (direction < 0 && startIndex === firstIndex) return items.length - 1;
        return startIndex + direction;
      };
      const sync = () => {
        if (desktopGallery()) {
          const activeIndex = items.findIndex((item) => item.classList.contains('is-dv-active'));
          if (activeIndex >= 0) index = activeIndex;
        } else {
          index = nearestIndex();
        }
        if (count) count.textContent = `${index + 1} / ${items.length}`;
        thumbs.forEach((t, k) => { t.classList.toggle('is-on', k === index); t.setAttribute('aria-selected', String(k === index)); });
        thumbs[index]?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      };
      syncGalleryState = sync;
      track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
      thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.index))));
      root.querySelectorAll('.dv-gal__nav').forEach((b) => b.addEventListener('click', () => {
        const direction = Number(b.dataset.dir);
        goTo(stepIndex(index, direction));
      }));
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') goTo(stepIndex(index, -1));
        if (e.key === 'ArrowRight') goTo(stepIndex(index, 1));
      });

      track.tabIndex = 0;

      /* Vue d'arrivée : image produit 2, posée immédiatement et sans animation,
         sans modifier l'ordre Shopify et sans laisser la variante précochée
         imposer son image au chargement. */
      const showInitialProductImage = () => {
        if (variantMediaRequested) return;
        goTo(variantSlotIndex(), 'auto');
        sync();
      };
      showInitialProductImage();
    }

    /* ---------- Visionneuse ---------- */
    const lb = root.querySelector('[data-dv-lightbox]');
    if (lb && track) {
      const img = lb.querySelector('img'); const counter = lb.querySelector('.dv-lb__count');
      let list = []; let pos = 0;
      const show = (i) => { pos = (i + list.length) % list.length; img.src = list[pos].dataset.zoom; img.alt = list[pos].dataset.alt || ''; counter.textContent = `${pos + 1} / ${list.length}`; };
      const open = (el) => { list = [...track.querySelectorAll('[data-zoom]')]; show(list.indexOf(el)); lb.classList.add('is-open'); document.documentElement.classList.add('dv-lock'); lb.querySelector('.dv-lb__close').focus(); };
      const close = () => { lb.classList.remove('is-open'); document.documentElement.classList.remove('dv-lock'); };
      track.addEventListener('click', (e) => {
        const el = e.target.closest('[data-zoom]');
        if (!el || window.matchMedia('(max-width: 989px)').matches) return;
        open(el);
      });
      root.querySelector('.dv-gal__zoom')?.addEventListener('click', () => {
        const el = items[index]?.matches('[data-zoom]') ? items[index] : track.querySelector('[data-zoom]');
        if (el) open(el);
      });
      lb.querySelector('.dv-lb__close').addEventListener('click', close);
      lb.querySelector('.dv-lb__prev').addEventListener('click', () => show(pos - 1));
      lb.querySelector('.dv-lb__next').addEventListener('click', () => show(pos + 1));
      lb.addEventListener('click', (e) => { if (e.target === lb) close(); });
      document.addEventListener('keydown', (e) => {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') close(); if (e.key === 'ArrowLeft') show(pos - 1); if (e.key === 'ArrowRight') show(pos + 1);
      });
    }

    /* ---------- Jauge livraison offerte (mise à jour après ajout) ---------- */
    const free = root.querySelector('[data-dv-free]');
    if (free) {
      const paintFree = (total) => {
        const t = Number(free.dataset.threshold); const left = t - total;
        free.querySelector('[data-dv-free-msg]').textContent = left > 0 ? free.dataset.msgLeft.replace('[montant]', money(left, currency)) : free.dataset.msgOk;
        free.querySelector('[data-dv-free-bar]').style.width = `${Math.min(100, (total / t) * 100)}%`;
      };
      document.addEventListener('skovn:cart:updated', (e) => { if (e.detail?.cart) paintFree(e.detail.cart.total_price); });
    }

    /* ---------- Mémorise le produit pour « Vus récemment » ---------- */
    try {
      const key = 'dv-recent'; const handle = root.dataset.handle;
      if (handle) {
        const list = JSON.parse(localStorage.getItem(key) || '[]').filter((h) => h !== handle);
        list.unshift(handle); localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
      }
    } catch (_) {}

    /* ---------- Barre collante ---------- */
    const sticky = document.querySelector(`[data-dv-sticky="${root.dataset.section}"]`);
    const anchor = root.querySelector('.dv-add');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const past = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', past);
      }).observe(anchor);
    }
  }

  /* ---------- Recommandations (API Shopify) ---------- */
  function initReco(scope) {
    scope.querySelectorAll('[data-dv-reco]').forEach((el) => {
      if (el.dataset.dvReady) return; el.dataset.dvReady = '1';
      fetch(el.dataset.url).then((r) => r.text()).then((html) => {
        const tpl = document.createElement('div'); tpl.innerHTML = html;
        const fresh = tpl.querySelector('[data-dv-reco]');
        if (fresh && fresh.querySelector('.dv-card')) { el.innerHTML = fresh.innerHTML; window.Douvella?.init(el); }
        else el.closest('section')?.setAttribute('hidden', '');
      }).catch(() => el.closest('section')?.setAttribute('hidden', ''));
    });
  }

  /* ---------- Vus récemment (localStorage + /products/x.js) ---------- */
  function initRecent(scope) {
    scope.querySelectorAll('[data-dv-recent]').forEach(async (el) => {
      if (el.dataset.dvReady) return; el.dataset.dvReady = '1';
      let list = [];
      try { list = JSON.parse(localStorage.getItem('dv-recent') || '[]'); } catch (_) {}
      list = list.filter((h) => h !== el.dataset.exclude).slice(0, Number(el.dataset.limit || 8));
      const section = el.closest('section');
      if (!list.length) { section?.setAttribute('hidden', ''); return; }
      const root = window.Shopify?.routes?.root || '/';
      const products = (await Promise.all(list.map((h) => fetch(`${root}products/${h}.js`).then((r) => r.ok ? r.json() : null).catch(() => null)))).filter(Boolean);
      if (!products.length) { section?.setAttribute('hidden', ''); return; }
      const cur = el.dataset.currency || 'EUR';
      el.querySelector('.dv-rail__track').innerHTML = products.map((p) => {
        const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=700` : '';
        return `<a class="dv-card dv-hover" href="${p.url}"><div class="dv-card__img dv-img">${img ? `<img src="${img}" alt="" loading="lazy">` : '<div class="dv-ph dv-ph--2"></div>'}</div><div class="dv-card__meta"><span class="dv-card__name">${p.title.replace(/</g, '&lt;')}</span><span class="dv-card__price">${p.price_varies ? 'Dès ' : ''}${money(p.price, cur)}</span></div></a>`;
      }).join('');
      section?.removeAttribute('hidden');
      window.Douvella?.init(section);
      window.dispatchEvent(new Event('resize'));
    });
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-dv-product]').forEach(initProduct);
    initReco(scope); initRecent(scope);
  }
  window.DouvellaProduct = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();